import { DateTime } from 'luxon';

/**
 * Returns a string in a format like '1:30:23 PM'
 * @param {string} isoDate ISO 8601 string.
 * @param {string} timeZone the time zone to use.
 */
export default function (isoDate, timeZone = false) {
  if (timeZone) {
    return `${DateTime.fromISO(isoDate).toFormat('h:mm a ZZZZ')}`;
  } else {
    return `${DateTime.fromISO(isoDate).toFormat('h:mm a')}`;
  }
}
